module.exports = __webpack_public_path__ + "media/images/pic/brodno/gallery/2021/otwarcie/thumbs/6-373a66185cb84f6c5351695e7ae9b8cb.webp";